import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectMorePage } from './projectMore';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    ProjectMorePage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectMorePage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class ProjectMorePageModule {}



// WEBPACK FOOTER //
// ./src/pages/projectMore/projectMore.module.ts